import { addResourceBundle } from '@egw/i18n'
import en from './src/i18n/locales/en.json'

addResourceBundle('en', 'features-settings', en)

export * from './src/constants'
export * from './src/pages/beneficiaries'
export * from './src/pages/default'
export * from './src/pages/personal-info'
export * from './src/utils'
